export enum ClientRequestsBreakpoint {
  FULL = '(min-width: 1000px)',
}

export enum ClientRequestsLayout {
  FULL = 'full',
  COMPACT = 'compact',
}
